import { render } from "./ForgeTeam.vue?vue&type=template&id=5041bbca&scoped=true&ts=true"
import script from "./ForgeTeam.vue?vue&type=script&lang=ts"
export * from "./ForgeTeam.vue?vue&type=script&lang=ts"

import "./ForgeTeam.vue?vue&type=style&index=0&id=5041bbca&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5041bbca"]])

export default __exports__